export const features = {
  productsServicesEnabled: true,
};
